<template>
  <div class="hot-links d-flex flex-column flex-sm-row">
    <a
      :href="getLink('print')"
      target="_blank"
      class="link"
      @click="onLinkClick('print')"
    >
      <img src="/images/4-g.png" alt="" />
      <span class="text">{{ printVersion }}</span>
    </a>
    <a
      v-if="leadsIds.length > 1 && isAgent"
      :href="getLink('table')"
      target="_blank"
      class="link"
      @click="onLinkClick('table')"
    >
      <img src="/images/tablet.svg" alt="" />
      <span class="text">{{ tableVersion }}</span>
    </a>
  </div>
</template>

<script>
import Locale from '../../../services/locale'
import { metrikaEvents } from '../../../services/metrika'

export default {
  name: 'HotLinks',
  props: {
    isAgent: Object,
    isInfractructure: Boolean,
    presentationId: String,
    isMap: Array,
    leadsIds: Array,
    localeService: Locale,
  },
  computed: {
    printVersion() {
      return this.localeService.getConstantTranslationByKey('print-version')
    },
    tableVersion() {
      return this.localeService.getConstantTranslationByKey('table-version')
    },
  },
  methods: {
    getLink(presentationVersion) {
      const query = new URLSearchParams()
      query.append('ids', this.leadsIds.join(','))
      query.append(presentationVersion, 'Y')
      this.presentationId && query.append('pId', this.presentationId)

      return `?${query.toString()}`
    },
    onLinkClick(version) {
      metrikaEvents.clickOnOpenPres(version)
    },
  },
}
</script>

<style scoped>
body.presentation-standard-view .link img {
  display: initial !important;
}

body.presentation-standard-view .hot-links a {
  font-weight: 700;
}

div.hot-links {
  margin-bottom: 100px;
}

@media (max-width: 991px) {
  div.hot-links {
    margin-bottom: 68px;
  }
  body.presentation-standard-view .hot-links a {
    display: none !important;
  }
}
</style>
